/** The current replay session id, read fresh because the recorder rotates it without notifying anyone. */
export const replaySessionId = (): string | null => {
  try {
    return window.OneUptimeReplay?.getSessionId?.() || null;
  } catch {
    // Span onStart calls this unguarded, so a throw would break the HTTP request.
    return null;
  }
};
